import './ThumbButton.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
export var ThumbButton = function ThumbButton(_ref) {
  var handleClick = _ref.handleClick,
    feedbackData = _ref.feedbackData,
    icon = _ref.icon,
    id = _ref.id;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var isDisabled = feedbackData !== id && feedbackData !== '';
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(isDisabled ? 'disabled' : '', "\n        ").concat(feedbackData === id ? 'active' : '', "\n        "),
    disabled: isDisabled,
    onClick: handleClick
  }, icon ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: icon
    },
    className: "icon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null));
};
export var commonStyles = "cg64923";
export var ltrStyles = "lgxcpcv";
export var rtlStyles = "r1ha024b";
export default ThumbButton;